import useSearchConfiguration from "hooks/useSearchConfiguration";
import useMinimumRefreshInterval from "views/hooks/useMinimumRefreshInterval";
import { durationToMS } from "util/DateTime";
const useDefaultIntervalForRefresh = () => {
  const { config } = useSearchConfiguration();
  const { data: minimumInterval } = useMinimumRefreshInterval();
  const minimumIntervalInMS = durationToMS(minimumInterval);
  const autoRefreshTimerangeOptions = config == null ? void 0 : config.auto_refresh_timerange_options;
  const defaultAutoRefreshInterval = config == null ? void 0 : config.default_auto_refresh_option;
  if (!config || !autoRefreshTimerangeOptions || !defaultAutoRefreshInterval) return null;
  if (durationToMS(defaultAutoRefreshInterval) < minimumIntervalInMS) {
    const availableIntervals = Object.entries(autoRefreshTimerangeOptions).filter(([interval]) => durationToMS(interval) >= minimumIntervalInMS).sort(([interval1], [interval2]) => durationToMS(interval1) > durationToMS(interval2) ? 1 : -1);
    return availableIntervals.length ? availableIntervals[0][0] : null;
  }
  return defaultAutoRefreshInterval;
};
export default useDefaultIntervalForRefresh;
